import React from 'react'
import { Redirect } from 'react-router-dom'

// Hooks
import { useGlobal } from '../../../../hooks'

const UIWrapperPageAuth = ({
  roles,
  laboratories,
  clients,
  sites,
  users,
  children,
}) => {
  const [{ me }] = useGlobal()

  // ------------------------------------------------------------------------
  //
  // User local authorization
  //
  // ------------------------------------------------------------------------

  if (roles || laboratories || clients || sites || users) {
    const checkLocalRoles = () => {
      if (roles && !roles.includes(me.id_role)) throw new Error()
    }

    const checkLocalLaboratories = () => {
      if (laboratories) {
        if ([0, ...laboratories].includes(me.laboratories)) return
        throw new Error()
      }
    }

    const checkLocalClients = () => {
      if (clients) {
        if ([0, ...clients].includes(me.clients)) return
        throw new Error()
      }
    }

    const checkLocalSites = () => {
      if (sites) {
        if ([0, ...sites].includes(me.sites)) return
        throw new Error()
      }
    }

    const checkLocalUsers = () => {
      if (users) {
        if ([1, ...users].includes(me.id)) return
        throw new Error()
      }
    }

    try {
      switch (me.id_role) {
        // Root
        case 1:
          break
        // Administrador
        case 2:
          checkLocalRoles()
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Analista
        case 3:
          checkLocalRoles()
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Ingeniero
        case 4:
          checkLocalRoles()
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Cliente
        case 5:
          checkLocalRoles()
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Muestreador
        case 6:
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Muestreador + cliente
        case 7:
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Buscador de muestras
        case 8:
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Inspector
        case 9:
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
        // Teck
        case 10:
          checkLocalLaboratories()
          checkLocalClients()
          checkLocalSites()
          checkLocalUsers()
          break
      }
    } catch (err) {
      return <Redirect to="/forbidden" />
    }
  }

  return children
}

export default UIWrapperPageAuth
